<template>
  <RevButton v-if="!error" :disabled="!url" :to="url" variant="primary">
    {{ ctaLabel }}
  </RevButton>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import { useStudentVerificationUrl } from './useStudentVerificationUrl'

defineProps<{ ctaLabel: string }>()

const { url, error } = useStudentVerificationUrl()
</script>
